import api from './index';

const login = (data) => api.post('/login', data);

const profile = () => api.get('/profile');

const updateProfile = (data) => api.post('/updateProfile', data);

const resetPassword = (data) => api.post('/resetPassword', data);

export {
  login, profile, updateProfile, resetPassword,
};
